<ng-container [ngSwitch]="loggedUser.role">
  <app-policy-individual
    *ngSwitchCase="commonService.userRoles.Individual">
  </app-policy-individual>
  <app-policy-legal-person
    *ngSwitchCase="commonService.userRoles.LegalPerson">
  </app-policy-legal-person>
  <app-policy-b2b-lease *ngSwitchCase="commonService.userRoles.B2BLease">
  </app-policy-b2b-lease>
</ng-container>



